<template>
  <div class="mappingRelationship">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>映射关系</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称/编号/备注"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">
          新建
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|array-integer#and': '0,1',
                'regex:name|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'regex:memo|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'mappingRelationship',
                title: '映射关系'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          :row-class-name="osg.lastRowClassName"
        >
          <c-table :fields="extFields">
            <template slot="extId">
              <el-table-column label="目标表" porp="extId" min-width="100px">
                <template slot-scope="scope">
                  {{ osg.codelabel('exts', scope.row.extId) }}
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row)">
                    归档
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="映射关系"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="c-dialog-full-screen"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
        labelWidth="130px"
        label-position="top"
        :inline="true"
      >
        <template slot="integrationCode">
          <el-select
            v-model="formData.integrationCode"
            placeholder="请选择"
            clearable
            filterable
            @clear="sourceTableClear"
          >
            <el-option
              v-for="item in options.sourceTable.concat(options.exts)"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @click.native="sourceTableClick(item)"
            ></el-option>
          </el-select>
        </template>
        <template slot="extId">
          <el-select
            v-model="formData.extId"
            placeholder="请选择"
            clearable
            filterable
            @change="targetTableChange"
          >
            <el-option
              v-for="item in options.exts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </c-form>
      <div class="c_flex c_flex_between c_item_center c-m-t-20 c-m-b-10">
        <div class="c_flex c_item_center">
          <h3 style="white-space: nowrap;">源表</h3>
          <h3 style="white-space: nowrap;margin-left:455px">目标表</h3>
        </div>
        <div>
          <el-button v-if="formData.exts.integrationType != 'ext'" @click="openJSON">
            解析JSON添加字段
          </el-button>
          <el-button @click="addRow">手动添加字段</el-button>
          <el-button @click="sameNameMapping">同名映射</el-button>
          <el-button @click="clearMapping">清除映射</el-button>
        </div>
      </div>
      <el-form ref="mapperForm" :model="formData" class="mapper-form" :show-message="false">
        <el-table
          ref="mapperTable"
          :data="formData.mapperList"
          :border="formData.mapperList.length > 0 ? true : false"
          class="mapper-table"
          :class="formData.mapperList.length > 0 ? 'mapper-table-border' : ''"
        >
          <el-table-column label="删除" align="center" width="50px">
            <template slot-scope="scope">
              <i
                class="el-icon-close c_pointer c_size_16"
                style="vertical-align:middle"
                @click="deleteRow(scope.$index)"
              ></i>
            </template>
          </el-table-column>
          <el-table-column prop="sourceField" width="170px">
            <template slot="header">
              <div class="c_flex c_item_center">
                <span class="c_red">*</span>
                <span style="margin:0 5px 0 3px">源表字段</span>
                <i
                  v-if="formData.exts.integrationType == 'ext'"
                  class="el-icon-refresh-right c_blue c_size_14 c_pointer"
                  @click="sourceFieldUpdate(formData.integrationCode)"
                ></i>
              </div>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'mapperList.' + scope.$index + '.sourceField'"
                :rules="{
                  required: true,
                  message: '请输入'
                }"
              >
                <el-select
                  v-if="formData.exts.integrationType == 'ext' && sourceFields.length > 0"
                  v-model="scope.row.sourceField"
                  placeholder="请选择"
                  clearable
                  filterable
                  allow-create
                  @clear="sourceFieldClear(scope.row)"
                >
                  <el-option
                    v-for="(item, i) in sourceFields"
                    :key="i"
                    :label="item.name"
                    :value="item.name"
                    @click.native="sourceFieldClick(scope.row, item)"
                    style="display:flex;justify-content:space-between"
                  >
                    <span>{{ item.name }}</span>
                    <span class="c-m-l-10">{{ item.nameDisp }}</span>
                  </el-option>
                </el-select>
                <el-input v-else v-model="scope.row.sourceField" clearable></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="描述" prop="sourceName" width="170px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.sourceName" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" width="100px" class-name="column-arrow">
            <img
              src="../../assets/arrow-right.png"
              style="width:50px;display:flex;margin:0 auto;"
            />
          </el-table-column>
          <el-table-column prop="targetField" width="170px">
            <template slot="header">
              <div class="c_flex c_item_center">
                <span class="c_red">*</span>
                <span style="margin:0 5px 0 3px">目标表字段</span>
                <i
                  v-if="formData.extId"
                  class="el-icon-refresh-right c_blue c_size_14 c_pointer"
                  @click="targetTableChange(formData.extId, 'toast')"
                ></i>
              </div>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'mapperList.' + scope.$index + '.targetField'"
                :rules="{
                  required: true,
                  message: '请选择'
                }"
              >
                <el-select
                  v-model="scope.row.targetField"
                  placeholder="请选择"
                  clearable
                  filterable
                  allow-create
                  @clear="targetFieldClear(scope.row)"
                >
                  <el-option
                    v-for="(item, i) in targetFields"
                    :key="i"
                    :label="item.name"
                    :value="item.name"
                    @click.native="targetFieldClick(scope.row, item)"
                    :disabled="
                      formData.mapperList.find(mapperItem => mapperItem.targetField == item.name)
                        ? true
                        : false
                    "
                    style="display:flex;justify-content:space-between"
                  >
                    <span>{{ item.name }}</span>
                    <span class="c-m-l-10">{{ item.nameDisp }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="描述" prop="targetName" width="170px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.targetName" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="targetType" width="110px">
            <template slot="header">
              <span class="c_red">*</span>
              类型
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'mapperList.' + scope.$index + '.targetType'"
                :rules="{
                  required: scope.row.targetField ? true : false,
                  message: '请输入'
                }"
              >
                <el-select
                  v-model="scope.row.targetType"
                  placeholder="请选择"
                  clearable
                  filterable
                  @change="targetTypeChange(scope.row)"
                >
                  <el-option
                    v-for="(item, i) in options.fieldValueType"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="数据处理规则" prop="supplementaryScriptId" width="170px">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.supplementaryScriptId"
                placeholder="请选择"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, i) in options.supplementaryScripts"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="是否作为唯一标识 更新策略" prop="unique" width="170px">
            <template slot-scope="scope">
              <div class="c_flex c_item_center">
                <el-checkbox
                  v-model="scope.row.unique"
                  true-label="1"
                  false-label="0"
                  class="c-m-r-20"
                  @change="uniqueChange(scope)"
                ></el-checkbox>
                <el-select
                  v-if="scope.row.unique == '1'"
                  v-model="scope.row.uniquedAction"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, i) in options.fieldMappingUpdatePolicy"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="字段值格式" prop="targetTypePattern" min-width="205px">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.targetType == 'Date'"
                v-model="scope.row.targetTypePattern"
                clearable
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="解析JSON"
      :visible.sync="json.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="c-m-b-20">
        请在下方输入外部系统的JSON格式数据，点击“解析并添加”按钮会自动将JSON中的所有属性添加到源表字段中。
      </div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 10, maxRows: 20 }"
        placeholder="请输入JSON格式数据"
        v-model="json.value"
      ></el-input>
      <div slot="footer">
        <el-button type="primary" @click="parseMapping">解析并添加</el-button>
        <el-button @click="json.show = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      tenantId: '',
      name: 'mappingRelationship',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: { mapperList: [], exts: {} },
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      options: {
        codecfg_sourceTable: {
          codeId: 'sourceTable'
        },
        codecfg_fieldValueType: {
          codeId: 'fieldValueType'
        },
        codecfg_fieldMappingUpdatePolicy: {
          codeId: 'fieldMappingUpdatePolicy'
        },
        sourceTable: [], // 源表
        exts: [], // 目标表
        supplementaryScripts: [] // 字段处理规则脚本
      },
      area: {
        options: this.osg.areaList
      },
      sourceFields: [], // 源表字段
      targetFields: [], // 目标表字段
      json: {
        show: false,
        value: ''
      }
    };
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('mappingRelationship', () => {
      this.getExts();
      this.osg.getFpi();
      this.getData();
      this.getSupplementaryScripts();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { mapperList: [], exts: {} };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:memo|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/mappingRelationship/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.formData = row;
      // 请求源表字段
      if (row.exts.integrationType == 'ext') {
        this.getFields(row.integrationCode, fields => {
          this.sourceFields = fields;
        });
      } else {
        this.sourceFields = [];
      }
      // 请求目标表字段
      this.getFields(row.extId, fields => {
        this.targetFields = fields;
      });
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate() && this.osg.validate('mapperForm')) {
        if (this.formData.mapperList.length == 0) {
          this.osg.toast('请至少添加一条字段映射', 'warning');
          return;
        }
        this.osg.ajax(
          'biz/mappingRelationship/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      } else {
        this.osg.toast('请填写必填项！', 'warning');
      }
    },
    doEnable(id) {
      this.osg.ajax('biz/mappingRelationship/enable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('biz/mappingRelationship/disable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除${row.name}？`, () => {
        this.osg.ajax('biz/mappingRelationship/remove.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('操作成功');
        });
      });
    },
    getExts() {
      this.osg.ajax(
        'biz/ext/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'asc'
        },
        res => {
          this.options.exts = res.data.map(item => {
            return {
              label: item.title,
              value: item._id,
              type: 'ext'
            };
          });
        },
        {
          noload: true
        }
      );
    },
    getFields(extId, callback) {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          extId,
          _all: '1',
          'is:state|integer#and': 1,
          'nin:type|array#and': 'title,gap,scan,button,bgImage,pushItem,dialog',
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          let array = [];
          // 通过name字段去重
          const seen = new Set();
          res.data.forEach(item => {
            if (!seen.has(item.name)) {
              seen.add(item.name);
              array.push(item);
            }
          });
          if (callback) callback(array);
        },
        {
          noload: true
        }
      );
    },
    // 源表选择
    sourceTableClick(item) {
      let oldIntegrationType = this.formData.exts.integrationType;
      this.formData.integrationName = item.label;
      this.formData.integrationCode = item.value;
      this.formData.exts.integrationType = item.type || '';
      if (item.type == 'ext') {
        // 当源表是系统内部表单时请求表单字段
        this.getFields(item.value, fields => {
          this.sourceFields = fields;
          // 自动添加全部字段到源表
          let mapperList = [];
          fields.map(field => {
            mapperList.push({
              sourceField: field.name,
              sourceName: field.nameDisp,
              targetField: '',
              targetName: '',
              targetType: '',
              targetTypePattern: '',
              supplementaryScriptId: '',
              unique: '0',
              uniquedAction: ''
            });
          });
          this.formData.mapperList = mapperList;
        });
      } else {
        this.sourceFields = [];
        // 当源表从内部系统表单改为外部系统表单时，清空源表字段
        if (oldIntegrationType == 'ext') {
          this.formData.mapperList = [];
        }
      }
    },
    // 源表清空
    sourceTableClear() {
      this.formData.integrationName = '';
      this.formData.integrationCode = '';
      this.formData.exts.integrationType = '';
      this.formData.mapperList = [];
      this.sourceFields = [];
    },
    // 目标表选择
    targetTableChange(extId, toast) {
      if (extId) {
        this.getFields(extId, fields => {
          this.targetFields = fields;
          if (toast) {
            this.osg.toast('目标表可选字段已更新');
          }
        });
      } else {
        // 清空目标表全部字段
        this.formData.mapperList.map(item => {
          item.targetField = '';
          item.targetName = '';
          item.targetType = '';
          item.targetTypePattern = '';
          item.supplementaryScriptId = '';
          item.unique = '0';
          item.uniquedAction = '';
        });
        this.targetFields = [];
      }
    },
    // 系统内 源表字段清空
    sourceFieldClear(item) {
      item.sourceName = '';
    },
    // 系统内 源表字段选择
    sourceFieldClick(item, field) {
      item.sourceName = field.nameDisp;
    },
    // 系统内 源表字段更新
    sourceFieldUpdate(extId) {
      this.getFields(extId, fields => {
        this.sourceFields = fields;
        this.osg.toast('源表可选字段已更新');
      });
    },
    // 目标表字段选择
    targetFieldClick(item, field) {
      item.targetName = field.nameDisp;
      item.targetField = item.targetField || field.name; // 同名映射时需要赋值
      item.targetType = 'string';
      if (field.type == 'datetime' || field.type == 'date' || field.type == 'time') {
        item.targetType = 'Date';
        item.targetTypePattern = 'yyyy-MM-dd HH:mm:ss';
      } else if (field.type == 'number' || field.frontEndConfig.number) {
        item.targetType = 'Integer';
      } else if (field.type == 'digit') {
        item.targetType = 'Double';
      } else {
        item.targetType = 'String';
      }
    },
    // 目标表字段清空
    targetFieldClear(item) {
      item.targetName = '';
      item.targetType = '';
      item.targetTypePattern = '';
    },
    // 查询字段处理规则脚本
    getSupplementaryScripts() {
      this.osg.ajax(
        'groovyScript/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:type|integer#and': 12,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.options.supplementaryScripts = res.data.map(item => {
            return {
              label: item.name,
              value: item._id
            };
          });
        }
      );
    },
    // 目标表字段 类型变更
    targetTypeChange(item) {
      if (item.targetType == 'Date') {
        item.targetTypePattern = 'yyyy-MM-dd HH:mm:ss';
      } else {
        item.targetTypePattern = '';
      }
    },
    // 目标表字段 是否作为唯一标识变更
    uniqueChange(scope) {
      let index = scope.$index;
      for (let i = 0; i < this.formData.mapperList.length; i++) {
        if (i == index) {
          if (scope.row.unique == '1') {
            scope.row.uniquedAction = 'update';
          } else {
            scope.row.uniquedAction = '';
          }
        } else {
          this.formData.mapperList[i].unique = '0';
          this.formData.mapperList[i].uniquedAction = '';
        }
      }
    },
    // 添加行
    addRow() {
      this.formData.mapperList.push({
        sourceField: '',
        sourceName: '',
        targetField: '',
        targetName: '',
        targetType: '',
        targetTypePattern: '',
        supplementaryScriptId: '',
        unique: '0',
        uniquedAction: ''
      });
    },
    // 删除行
    deleteRow(index) {
      this.osg.confirm('是否确认删除？', () => {
        this.formData.mapperList.splice(index, 1);
      });
    },
    // 同名映射
    sameNameMapping() {
      if (!this.osg.validate()) {
        this.osg.toast('请填写必填项！', 'warning');
        return;
      }
      this.osg.confirm(
        '同名映射：将以左侧源表字段为基准，自动将右侧目标表中同名的字段选中。已填写的目标表字段不会更新。',
        () => {
          this.formData.mapperList.map(item => {
            if (item.sourceField && !item.targetField) {
              // 查找同名字段
              let targetField = this.targetFields.find(field => field.name == item.sourceField);
              if (targetField) {
                this.targetFieldClick(item, targetField);
              }
            }
          });
        }
      );
    },
    // 清除映射
    clearMapping() {
      this.osg.confirm('清除映射：将清空右侧目标表全部字段！', () => {
        this.formData.mapperList.map(item => {
          item.targetField = '';
          item.targetName = '';
          item.targetType = '';
          item.targetTypePattern = '';
          item.supplementaryScriptId = '';
          item.unique = '0';
          item.uniquedAction = '';
        });
      });
    },
    // 打开JSON弹窗
    openJSON() {
      this.json.show = true;
    },
    parseMapping() {
      if (!this.json.value) {
        this.osg.toast('JSON数据不能为空', 'warning');
        return;
      }
      if (!this.osg.isJson(this.json.value)) {
        this.osg.toast('您输入的数据不是JSON格式，请检查修改后重试。', 'error');
        return;
      }
      let obj = JSON.parse(this.json.value);
      let mapperList = [];
      for (let key in obj) {
        mapperList.push({
          sourceField: key,
          sourceName: '',
          targetField: '',
          targetName: '',
          targetType: '',
          targetTypePattern: '',
          supplementaryScriptId: '',
          unique: '0',
          uniquedAction: ''
        });
      }
      this.formData.mapperList = mapperList;
      this.json.show = false;
      this.osg.toast('源表字段已添加完成');
    }
  }
};
</script>
<style lang="scss">
.mappingRelationship {
  .el-form--label-top.el-form--inline {
    .el-form-item {
      min-width: 197.5px;
    }
  }
  .mapper-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .mapper-table-border {
    border-left: 1px solid #ebeef5 !important;
  }
  .mapper-table {
    thead {
      th {
        height: 50px;
        border-top: 1px solid #ebeef5;
        background-color: #f2f2f2;
        &.column-arrow {
          border-top: none;
          background-color: transparent;
        }
      }
    }
    tbody {
      tr {
        td:nth-child(3) {
          border-right: 1px solid #ebeef5 !important;
        }
        &:hover {
          td.column-arrow {
            background-color: #fff !important;
          }
        }
      }
    }
    &::before {
      display: none;
    }
    .column-arrow {
      border-bottom: 0 !important;
      border-right: 1px solid #ebeef5 !important;
    }
  }
}
</style>
